module.exports = __webpack_public_path__ + "static/img/7.af0e5a48.png";